<template>
    <div class="apprentice-simple-card">
        <h4 class="card-title">{{ $t('organization.general') }}</h4>

        <div class="row">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="organization-address-setting">
                    <b-form-group
                        class="organization-name"
                        label-for="organization-name-input"
                        :label="$t('common.name')">
                        <b-form-input
                            id="organization-name-input"
                            v-model="name"
                            :placeholder="$t('organization.organization_name')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="organization-active"
                        label-for="organization-active-input"
                        :label="$t('organization.active')">
                        <b-form-checkbox
                            v-model="active"
                            :unchecked-value="0"
                            :value="1"
                            switch>
                        </b-form-checkbox>
                    </b-form-group>

                    <b-button
                        class="btn-save btn-save-school-settings"
                        variant="primary"
                        @click="save()">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </div>
        </div>

        <!--        <table class="table table-striped">-->
        <!--            <tbody>-->
        <!--                <tr>-->
        <!--                    <td>-->
        <!--                        Naam-->
        <!--                    </td>-->
        <!--                    <td>-->
        <!--                        <b-form-input-->
        <!--                            v-model="name"-->
        <!--                        ></b-form-input>-->
        <!--                    </td>-->
        <!--                </tr>-->
        <!--                <tr>-->
        <!--                    <td>-->
        <!--                        Actief-->
        <!--                    </td>-->
        <!--                    <td>-->
        <!--                        <b-form-checkbox-->
        <!--                            v-model="active"-->
        <!--                            :unchecked-value="0"-->
        <!--                            :value="1"-->
        <!--                            switch-->
        <!--                        >-->
        <!--                        </b-form-checkbox>-->
        <!--                    </td>-->
        <!--                </tr>-->
        <!--            </tbody>-->
        <!--        </table>-->
    </div>
</template>

<script>
export default {
    name: 'design-2021-organization-settings-general-component',
    props: ['organizationIn'],
    data() {
        return {
            name: this.organizationIn.name,
            active: this.organizationIn.active,
        };
    },
    methods: {
        save() {
            this.alert.saving();

            let data = {
                id: this.organizationIn.id,
                name: this.name,
                active: this.active,
            };

            this.axios.post(this.routes.organizationGeneralStore(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
